import React from "react"
import Button from "../../../shared/components/atoms/button/button"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./main-autopauta-users.scss"

const MainAutopautaUsers = props => {
  const homeLink = siteUrl + "/magazin/"

  return (
    <div className="f-autopauta2">
      <div className="f-autopauta2-content">
        <h3 className="f-autopauta2-copy">{props.autopauta.tituloMagazin}</h3>
        <p>{props.autopauta.descripcion}</p>
        <img
          alt={props.autopauta.imagenDestacada.description}
          src={props.autopauta.imagenDestacada.file.url}
        />
        <a href={homeLink + props.autopauta.botonRedireccion}>
          <Button
            className="primary-blue alter short"
            title={props.autopauta.boton}
          />
        </a>
      </div>
    </div>
  )
}

export default MainAutopautaUsers
